import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import axios, { CancelTokenSource } from 'axios';
import { actions as ReferralsActions } from '../../../redux/modules/referrals';
import { ReducerState } from '../../../redux/modules';
import APSearchInput from '../../atoms/APSearchInput';
import { withTranslate } from '../../../core/TenantProvider';

interface APSearchBarProps {
  getReferralsSearchDetail: Function,
  referralsSearchReset: Function,
  hideSearchBar: Function,
  className?: string,
  referralsViewType: string,
  allAffiliatesNumbers?: Array<string>,
  translate: Function
}

type APSearchBarState = {
  source: AbortController;
};

class APSearchBar extends Component<APSearchBarProps, APSearchBarState> {

  state: APSearchBarState = {
    source: new AbortController()
  }

  constructor(props: any) {
    super(props);
    this.referralsSearchReset = this.referralsSearchReset.bind(this);
    this.getReferralsSearchResults = this.getReferralsSearchResults.bind(this);
  }

  referralsSearchReset = () => {
    const { referralsSearchReset } = this.props;
    referralsSearchReset();
    const { source } = this.state;
    source.abort();
  }

  getReferralsSearchResults = (searchValue: string) => {
    const {
      referralsViewType,
      allAffiliatesNumbers,
      translate
    } = this.props;

    const { source } = this.state;

    if (searchValue !== '') {
      this.props.getReferralsSearchDetail(searchValue, referralsViewType, allAffiliatesNumbers, translate);
    }
  }

  render() {
    const { hideSearchBar } = this.props;
    return (
      <APSearchInput
        resetData={this.referralsSearchReset}
        hideSearchBar={hideSearchBar}
        getSearchResults={this.getReferralsSearchResults}
      />
    );
  }
}

const mapStateToProps = (state: ReducerState) => ({
  referralsViewType: state.referrals?.referralsViewType,
  allAffiliatesNumbers: state.referrals?.allAffiliatesNumbers
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  getReferralsSearchDetail: ReferralsActions.getReferralsSearchDetail,
  referralsSearchReset: ReferralsActions.referralsSearchReset,
}, dispatch);

export default withTranslate(
  connect(mapStateToProps, mapDispatchToProps)(APSearchBar)
);
